export const checkFiltersModule = {
  name: 'Check Filters',
};
